import { useEffect, useState } from "react";

import { Button } from "../ui/button";
import {
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPanel,
  DialogPopup,
  DialogTitle,
} from "../ui/dialog";
import { Input } from "../ui/input";

export const DESIGN_ADD_EVIDENCE_URL_PLACEHOLDER = "https://…";

/**
 * Captures one Design Example evidence URL. Nothing fetches it: the URL folds
 * into the operation's brief, and the Skill Bundle decides what to do with it,
 * the same way the retired Design dialog's URL chip behaved.
 */
export function DesignAddEvidenceUrlDialog(props: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onAdd: (url: string) => void;
}) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (props.open) setUrl("");
  }, [props.open]);
  const ready = url.trim().length > 0;
  const add = () => {
    if (!ready) return;
    props.onAdd(url.trim());
    props.onOpenChange(false);
  };

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogPopup data-design-add-evidence-url-dialog>
        <DialogHeader>
          <DialogTitle>Add URL</DialogTitle>
          <DialogDescription>
            Evidence that lives at a link rather than on disk. It rides the brief alongside the
            files you attach.
          </DialogDescription>
        </DialogHeader>
        <DialogPanel>
          <Input
            autoFocus
            type="url"
            value={url}
            aria-label="Design Example evidence URL"
            placeholder={DESIGN_ADD_EVIDENCE_URL_PLACEHOLDER}
            onChange={(event) => setUrl(event.target.value)}
            onKeyDown={(event) => {
              if (event.key !== "Enter") return;
              event.preventDefault();
              add();
            }}
          />
        </DialogPanel>
        <DialogFooter>
          <Button variant="ghost" onClick={() => props.onOpenChange(false)}>
            Cancel
          </Button>
          <Button disabled={!ready} onClick={add}>
            Add
          </Button>
        </DialogFooter>
      </DialogPopup>
    </Dialog>
  );
}
